import Vue from 'vue';

import Vuelidate from 'vuelidate'
Vue.use(Vuelidate);

import Toasted from 'vue-toasted';
Vue.use(Toasted)

Vue.component('newsletter-home', require('../components/index/NewsletterHome.vue').default);

Vue.config.productionTip = false;
Vue.config.devtools = true;

if (document.getElementById("vue-newsletter-home")) {
    new Vue({
        el: '#vue-newsletter-home',
    });
}